import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ayurveda from '../assets/ThingsToDo/Ayurvedic-Therapies-For-Stress-Relief.webp';
import diving from '../assets/ThingsToDo/unadiving1.jpg';
import elephantRide from '../assets/ThingsToDo/elephant-back-riding.jpg';
import fishing from '../assets/ThingsToDo/S4.jpg';
import ballooning from '../assets/ThingsToDo/hot-air-baloon.jpg';
import jeepSafari from '../assets/ThingsToDo/2409696_orig.jpg';
import whiteWaterRafting from '../assets/ThingsToDo/rafting7.jpg';
import riverSafari from '../assets/ThingsToDo/river-safari-slider1.jpg';
import snorkeling from '../assets/ThingsToDo/Snorkelers_2.jpg';
import teaTasting from '../assets/ThingsToDo/Tea-Tasting.avif';
import templeVisit from '../assets/ThingsToDo/Buddhist-Temples-in-Sri-Lanka.jpg';
import wildlifeTour from '../assets/ThingsToDo/protect-the-environment-on-your-sri-lanka-wildlife-safari-header.jpg';

const ThingsToDo = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const activities = [
        {
            image: ayurveda,
            title: t('thingsToDoSection.activities.ayurveda.title'),
            alt: t('thingsToDoSection.activities.ayurveda.alt'),
            route: '/ayurveda',
        },
        {
            image: diving,
            title: t('thingsToDoSection.activities.diving.title'),
            alt: t('thingsToDoSection.activities.diving.alt'),
            route: '/diving',
        },
        {
            image: elephantRide,
            title: t('thingsToDoSection.activities.elephantRide.title'),
            alt: t('thingsToDoSection.activities.elephantRide.alt'),
            route: '/elephant-ride',
        },
        {
            image: fishing,
            title: t('thingsToDoSection.activities.fishing.title'),
            alt: t('thingsToDoSection.activities.fishing.alt'),
            route: '/fishing',
        },
        {
            image: ballooning,
            title: t('thingsToDoSection.activities.ballooning.title'),
            alt: t('thingsToDoSection.activities.ballooning.alt'),
            route: '/ballooning',
        },
        {
            image: jeepSafari,
            title: t('thingsToDoSection.activities.jeepSafari.title'),
            alt: t('thingsToDoSection.activities.jeepSafari.alt'),
            route: '/jeep-safari',
        },
        {
            image: whiteWaterRafting,
            title: t('thingsToDoSection.activities.whiteWaterRafting.title'),
            alt: t('thingsToDoSection.activities.whiteWaterRafting.alt'),
            route: '/white-water-rafting',
        },
        {
            image: riverSafari,
            title: t('thingsToDoSection.activities.riverSafari.title'),
            alt: t('thingsToDoSection.activities.riverSafari.alt'),
            route: '/river-safari',
        },
        {
            image: snorkeling,
            title: t('thingsToDoSection.activities.snorkeling.title'),
            alt: t('thingsToDoSection.activities.snorkeling.alt'),
            route: '/snorkeling',
        },
        {
            image: teaTasting,
            title: t('thingsToDoSection.activities.teaTasting.title'),
            alt: t('thingsToDoSection.activities.teaTasting.alt'),
            route: '/tea-tasting',
        },
        {
            image: templeVisit,
            title: t('thingsToDoSection.activities.templeVisit.title'),
            alt: t('thingsToDoSection.activities.templeVisit.alt'),
            route: '/temple-visit',
        },
        {
            image: wildlifeTour,
            title: t('thingsToDoSection.activities.wildlifeSafari.title'),
            alt: t('thingsToDoSection.activities.wildlifeSafari.alt'),
            route: '/wildlife-safari',
        },
    ];

    return (
        <div className="py-16 px-4 sm:px-8 lg:px-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                {t('thingsToDoSection.title')}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-10 place-items-center max-w-7xl mx-auto">
                {activities.map((activity, index) => (
                    <div
                        key={index}
                        className="relative bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transform transition-all duration-500 hover:scale-105 group"
                        style={{ width: '300px' }}
                    >
                        {/* Image */}
                        <div className="relative overflow-hidden">
                            <img
                                src={activity.image}
                                alt={activity.alt}
                                className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            {/* Hover Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-90 transition-opacity duration-300 flex items-center justify-center">
                                <button
                                    onClick={() => navigate(activity.route)}
                                    className="px-6 py-3 bg-[#C58E2F] text-[#FFFFFF] font-semibold rounded-lg hover:bg-[#A57324] transition-transform duration-200 transform hover:scale-105"
                                >
                                    {t('thingsToDoSection.viewMore')}
                                </button>
                            </div>
                        </div>
                        {/* Title */}
                        <div className="bg-[#F8F1E9] text-[#122C56] text-center py-4 px-3 border-t-2 border-[#C58E2F]">
                            <h3 className="text-lg md:text-xl font-semibold tracking-tight">{activity.title}</h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ThingsToDo;